<template>
  <div>
    <!--头部搜索框-->
    <b-row align-h="between" class="mt-3 mb-3">
      <b-col cols="12">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              type="search"
              v-model="searchForm.searchKeyWord"
              placeholder="Search here..."
              @keyup.enter="keySearch"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button
                  variant="primary"
                  @click="keySearch"
                  size="sm"
                  class="my-2 my-sm-0"
                >
                  <i class="fa fa-search"></i>
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <div v-for="(item, index) in tableData" :key="index">
      <b-row class="ml-1 mr-1">
        <b-col class="col-auto p-2 d-flex justify-content-start">
          <b-img
            class="mr-3"
            left
            :src="
              item.feedbackPersonImgUrl || '/image/static/img/missing-face.png'
            "
            style="width: 2.5em; height: 2.5em"
            rounded="circle"
            alt="Left image"
          ></b-img>
        </b-col>
        <b-col class="col p-0 d-flex flex-column mt-1 mb-1 mr-2">
          <b-row>
            <b-col class="p-2 d-flex justify-content-start">
              <h6 class="span-color-dark">
                {{ item.feedbackPersonName || 'anonymous' }}
                <b-badge
                  v-for="(item, index) in item.atPersonList"
                  :key="index"
                  class="mr-1"
                  :variant="item.isAtMe === 'Y' ? 'info' : 'light'"
                  >@{{ item.atPersonName }}</b-badge
                >
              </h6>
            </b-col>
            <b-col class="col-auto d-flex justify-content-end">
              <b-button
                variant="light"
                size="sm"
                v-if="item.currentPerson === 'Y' && item.feedbackStatus === 'Y'"
                style="height: 30px"
              >
                <b-icon
                  icon="x"
                  font-scale="1.5"
                  aria-hidden="true"
                  style="color: #fa5c7c"
                  @click="deleteMessage(item)"
                ></b-icon>
              </b-button>
              <h6
                class="span-color-dark mt-2"
                v-if="item.feedbackStatus === 'N'"
              >
                <b-badge variant="danger">{{
                  $l('tips_Deleted') || '已删除'
                }}</b-badge>
              </h6>
            </b-col>
            <b-col class="col-auto d-flex justify-content-end mt-2">
              <span class="mr-1 text-muted">{{ item.displayDate }}</span>
              <span class="mr-1 text-muted">{{ item.displayTime }}</span>
            </b-col>
          </b-row>
          <b-row class="mr-1">
            <b-col cols="12" class="col p-2">
              <p
                class="feed-message"
                :class="{ deleteLine: item.feedbackStatus === 'N' }"
                v-html="item.feedbackMessage"
              ></p>
            </b-col>
          </b-row>
          <b-row v-if="item.prjFileCode">
            <b-col class="col p-2 mr-2">
              <a class="text-muted" @click="download(item)" role="button">
                <i class="fa fa-paperclip"></i>
                <span class="ml-2">attachment</span>
              </a>
            </b-col>
          </b-row>
          <el-divider style="margin: 0px"></el-divider>
        </b-col>
      </b-row>
    </div>
    <js-pagination
      v-if="!isEmpty"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      align="right"
      size="sm"
      @change="pageChange"
    />
    <form class="mt-2 border">
      <b-row>
        <b-col>
          <b-form-textarea
            class="noborder"
            id="textarea-default"
            :placeholder="this.$l('tips_input_comments') || '请输入消息内容'"
            rows="5"
            v-model="addComments.feedbackMessage"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <b-row class="p-2 bg-light">
        <b-col cols="9">
          <b-row>
            <span class="mt-1 mr-2" style="font-size: 14px; font-weight: 400"
              >@</span
            >
            <dict-select
              v-model="addComments.atPersonCode"
              url="/digitalCenter/common/dict/baseUser"
              :placeholder="$l('tips_select_at') || '选择提醒谁看'"
              size="small"
              style="width: 95%"
              filterable
              :multiple="true"
              clearable
              :options="{ label: 'label', value: 'code' }"
            ></dict-select>
          </b-row>
        </b-col>
        <b-col cols="3" class="text-right">
          <b-button size="sm" variant="success" @click="save">
            <i class="fa fa-send-o mr-1"></i>
            {{ $l('btn_send_comments') || 'Submit' }}
          </b-button>
        </b-col>
      </b-row>
    </form>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    params: {
      default: null,
      type: Object,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
    height: {
      default: 272,
      type: Number,
    },
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isEmpty: false,
      isBusy: false,
      max: 100,
      searchForm: {
        prjCode: '',
        searchKeyWord: '',
      },
      tableData: [],
      tableFields: [
        {
          key: 'showComments',
          label: '反馈信息',
          tdClass: 'align-middle',
        },
      ],
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
      addComments: {
        prjCode: '',
        feedbackMessage: '',
        atPersonCode: [],
      },
    }
  },
  methods: {
    load(params) {
      this.init(params)
    },
    init(params) {
      if (params.prjCode === '') {
        return
      }
      this.searchForm.prjCode = params.prjCode
      this.page.pageTotal = 0
      this.page.curPage = 1
      this.page.pageSize = 5
      this.getData(this.searchForm)
    },
    getData(params) {
      this.isBusy = true
      this.$api
        .projectInfoFeedbackListApi({
          ...(params || this.params),
          ...this.page,
        })
        .then((res) => {
          this.isBusy = false
          let totalCount = res.body.count
          this.tableData = res.body.data

          this.tableData.forEach((item) => {
            if (item.feedbackMessage !== null) {
              // 替换项目说明中的空格
              item.feedbackMessage = item.feedbackMessage
                .replace(/ /g, '&nbsp;')
                .replace(/\n/g, '<br/>')
            }
          })

          if (totalCount > 0) {
            this.isEmpty = false
            this.page.pageTotal = res.body.count
            this.page.curPage = res.body.curPage
            this.page.pageSize = res.body.pageSize
          } else {
            this.isEmpty = true
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    keySearch() {
      this.page.curPage = 1
      this.page.pageSize = 5
      this.getData(this.searchForm)
    },
    resetSearch() {
      this.searchForm.searchKeyWord = ''
      this.addComments.feedbackMessage = ''
      this.addComments.atPersonCode = []
      this.getData(this.searchForm)
      this.$emit('refresh')
    },
    // 子项目列表分页查询
    pageChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.getData(this.searchForm)
    },
    // 加载表单
    save() {
      if (this.addComments.feedbackMessage === '') {
        this.$message({
          showClose: true,
          message: this.$l('tips_input_comments') || '请输入消息内容',
          type: 'warning',
        })
        return
      }
      this.addComments.prjCode = this.searchForm.prjCode
      this.$api.projectInfoFeedbackSaveApi(this.addComments).then(() => {
        this.$message({
          showClose: true,
          message: this.$l('tips_save_ok') || '保存成功！',
          type: 'success',
        })
        this.resetSearch()
      })
    },
    download(row) {
      if (row.prjFileUrl) {
        // 兼容之前上传的有记录完整路径的上传文档
        window.open(row.prjFileUrl)
      } else {
        // 根据上传的id，直接使用阿里云地址传参获取下载
        window.open(this.$osscdn(row.prjFileCode))
      }
    },
    deleteMessage(item) {
      let delParams = {
        feedbackCode: item.feedbackCode,
      }
      this.$confirm(this.$l('INDEX.tips_question_delete') || '是否删除？', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确认',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.projectInfoFeedbackModiStatusApi(delParams).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.resetSearch()
          })
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.border {
  border: 1px solid #dee2e6 !important;
  border-radius: 0.25rem !important;
}

.noborder {
  border: 0px;
}

.p-2 {
  margin-left: 0px;
  margin-right: 0px;
  padding: 0.5rem !important;
}
.bg-light {
  background-color: #f8f9fa !important;
  border-radius: 0.25rem !important;
}
.span-color-dark {
  color: #6c757d !important;
  font-size: 15px;
  font-weight: 700;
}
.text-muted {
  font-size: 14px;
  color: #6c757d !important;
}
.feed-message {
  font-size: 14px;
  font-weight: 400;
  color: #6c757d !important;
  &.deleteLine {
    text-decoration: line-through;
  }
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
</style>
